import { DatePicker, TimeRangePickerProps } from "antd";
import { DateTime } from "luxon";
import luxonGenerateConfig from "rc-picker/lib/generate/luxon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ensureNumber } from "@intelligems/ig-utils";

import { useGetOrg } from "../../../../api/organizations/get-organization";
import { updateSitewideDashboardFilter } from "../../../../store/slices/sitewideDashboardFilters";
import { IAppState } from "../../../../store/types/store";

const LuxonDatePicker =
  DatePicker.generatePicker<DateTime>(luxonGenerateConfig);

const { RangePicker } = LuxonDatePicker;

// @ts-ignore
const rangePresets: TimeRangePickerProps["presets"] = [
  {
    label: "Today",
    value: [
      // @ts-ignore
      DateTime.now().startOf("day"),
      // @ts-ignore
      DateTime.now(),
    ],
  },
  {
    label: "Yesterday",
    // @ts-ignore
    value: [DateTime.now().minus({ days: 1 }).startOf("day"), DateTime.now()],
  },
  {
    label: "Last 7 days",
    // @ts-ignore
    value: [DateTime.now().minus({ days: 7 }).startOf("day"), DateTime.now()],
  },
  {
    label: "Last 30 days",
    // @ts-ignore
    value: [DateTime.now().minus({ days: 30 }).startOf("day"), DateTime.now()],
  },
];

export const DateRangePicker = () => {
  const dispatch = useDispatch();
  const sitewideDashboardFilters = useSelector(
    (state: IAppState) => state.sitewideDashboardFilters
  );
  const org = useGetOrg();
  return (
    <RangePicker
      timezone={org?.data?.org?.timezone ?? "UTC"}
      value={[
        sitewideDashboardFilters.startTime
          ? DateTime.fromMillis(
              ensureNumber(sitewideDashboardFilters.startTime)
            )
          : null,
        sitewideDashboardFilters.endTime
          ? DateTime.fromMillis(ensureNumber(sitewideDashboardFilters.endTime))
          : null,
      ]}
      onChange={(e) => {
        dispatch(
          updateSitewideDashboardFilter({
            key: "startTime",
            value: e ? e[0]!.toMillis() : null,
          })
        );
        dispatch(
          updateSitewideDashboardFilter({
            key: "endTime",
            value: e ? e[1]!.toMillis() : null,
          })
        );
      }}
      style={{ height: "40px" }}
      // @ts-ignore
      presets={rangePresets}
    />
  );
};
